import { useStore } from "../stores/store";
import { AppAbility } from "../stores/casl.store";

type Action = "manage" | "create" | "read" | "update" | "delete" | "execute" | "publish" | "configure" | "import" | "export";
type Subject =
  | "all"
  | "organization"
  | "workflow"
  | "campaign"
  | "channel"
  | "cdp"
  | "integration"
  | "conversation"
  | "user"
  | "role"
  | "analytics"
  | "billing"
  | "apiKey"
  | "webhook"
  | "whatsapp-onboarding";

export const usePermission = () => {
  const { caslStore } = useStore();

  // Note: Roles are now managed directly in AuthContext via capability roles
  // No need to sync from user.roles anymore - permissions are set when:
  // 1. Token is parsed and capability roles are extracted
  // 2. Organization is switched
  // 3. Token is refreshed

  const can = (action: Action, subject: Subject): boolean => {
    // If permissions are still loading, grant access by default
    // This prevents items from being hidden before permissions are resolved
    if (caslStore.isLoading) {
      return true;
    }
    return caslStore.ability.can(action, subject);
  };

  const cannot = (action: Action, subject: Subject): boolean => {
    // If permissions are still loading, don't deny access
    if (caslStore.isLoading) {
      return false;
    }
    return caslStore.ability.cannot(action, subject);
  };

  return {
    can,
    cannot,
    ability: caslStore.ability,
    isLoading: caslStore.isLoading
  };
};

